import { render, staticRenderFns } from "./MonthlyProfitLoss.vue?vue&type=template&id=ef68f830&"
import script from "./MonthlyProfitLoss.vue?vue&type=script&lang=js&"
export * from "./MonthlyProfitLoss.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyProfitLoss.vue?vue&type=style&index=0&id=ef68f830&prod&scopped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports